export const alertsReducerKey = 'alertsReducer';

export const saveAlertsType = 'saveAlertsType';
export const removeAlertActionType = 'removeAlertActionType';
export const alertDeleteStartType = 'alertDeleteStartType';
export const handleViewDeleteModalType = 'handleViewDeleteModalType';
export const setRefetchType = 'setRefetchType';
export const setMountedType = 'setMountedType';
